import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface AppStore {
  lang: 'uk' | 'en' | 'ru'
  cartCount: number
  setLang: (lang: 'uk' | 'en' | 'ru') => void
  setCartCount: (n: number) => void
}

export const useAppStore = create<AppStore>()(
  persist(
    (set) => ({
      lang: 'uk',
      cartCount: 0,
      setLang: (lang) => set({ lang }),
      setCartCount: (cartCount) => set({ cartCount }),
    }),
    { name: 'tg-shop-app' },
  ),
)
